<template>
  <div style="background-color: #FFFFFF;padding: 5px;">
    <el-tabs style="margin-left:20px" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="item in counts" :key="item.key" :label="item.title +'('+ item.val.length +')'" :name="item.key">
        <template v-for="devices in item.val">
          <div style="margin-bottom: 20px;">
            <el-row>
              <el-col :span="24">
                <div class="grid-content" style="font-size: 16px; color: #000;">
                  <span style="margin-right: 10px;">
                    <i v-if="devices.online == '1'" class="el-icon-circle-close" style="color: #e54d42;"></i>
                    <i v-else class="el-icon-circle-check" style="color: #39b54a;"></i>
                  </span>
                  <span style="margin-right: 13px;" v-show="devices.title != ''">{{ devices.title}}</span>
                  <span style="margin-right: 5px;">{{ devices.uid }}</span>
                  <span style="color: #e54d42;font-size: 12px;">{{devices.flowUnqualified =='1'?"(未达标)":""}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:6px">
              <el-col :span="2">
                <div class="grid-content">
                  <span>实时流量：{{ devices.liveFlow }}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content">
                  <span>核定流量:{{devices.approvedFlow}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top:6px">
              <el-col :span="2">
                <div class="grid-content">
                  <span>电量:{{devices.battery}}%</span>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">
                  <span>电池电压：{{ devices.braw }}v</span>
                </div>
              </el-col>
              <el-col :span="2">
                <div class="grid-content">
                  <span>信号:{{ devices.signal }}dB</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content">
                  <span>充电状态:{{ devices.chargeValue }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'total',
      counts: [
        { 'title': '全部', key: "total", val: [] },
        { 'title': '在线', key: "online", val: [] },
        { 'title': '离线', key: "offline", val: [] },
        { 'title': '无网络对接', key: "offlineDock", val: [] },
        { 'title': '流量未达标', key: "flowUnqualified", val: [] },
      ],
      chargeValues: { no: '未充电', charging: '充电中', full: '已充满' }

    }
  },
  watch: {
    '$store.state.profile': {
      handler() {
        this.getGroupUsers()
      }
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getGroupUsers() {
      let json = {
        "cmd": "gd2022Devices",
      }
      this.ws.send(json);
    },
    filterItems(counts, items) {
      return counts.map(category => {
        let filtered = [];
        const key = category.key;

        if (key === "total") {
          // 全部项目
          filtered = [...items];
        }
        else if (key === "online") {
          // 筛选在线项目
          filtered = items.filter(item => item.online === '1');
        }
        else if (key === "offline") {
          // 筛选离线项目
          filtered = items.filter(item => item.online === '0');
        }
        else if (key === "offlineDock") {
          // 筛选无网络对接项目
          filtered = items.filter(item => item.offlineDock === '1');
        }
        else if (key === "flowUnqualified") {
          // 筛选流量未达标项目
          filtered = items.filter(item => item.flowUnqualified === '1');
        }

        return { ...category, val: filtered };
      });
    }
  },
  mounted() {
    this.getGroupUsers()
  },
  created() {
    this.ws.addCallback("gd2022DevicesAck", (res) => {
      if (res.items) {
        res.items.forEach(item => {
          console.log(555, item);

          item.chargeValue = this.chargeValues[item.charge] || '';
        });
        this.counts = this.filterItems(this.counts, res.items)
        console.log(1112, this.counts);

      }
    })
  },
}
</script>

<style>
</style>